import { render } from "./BaseNavigation.vue?vue&type=template&id=c1ac3fd6&scoped=true"
import script from "./BaseNavigation.vue?vue&type=script&lang=js"
export * from "./BaseNavigation.vue?vue&type=script&lang=js"

import "./BaseNavigation.vue?vue&type=style&index=0&id=c1ac3fd6&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/gafwa_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1ac3fd6"]])

export default __exports__